import { AccessorialData } from './accessorial-data';
import { AccessorialUnitOfMeasureData } from './accessorial-unit-of-measure-data';
import { LoadAccessorialData } from './load-accessorial-data';

export interface LoadAccessorialDetailData extends LoadAccessorialData {
  accessorial: AccessorialData;
  accessorialUnitOfMeasure: AccessorialUnitOfMeasureData;
}
